// Editproductitem.js

<template>
    <div class="container">
        <div class="card text-dark text-left">
            <div class="card-header font-weight-bold">
                <h3>Edit Products</h3>
                <a>
                  <router-link to="/viewlistproduct">
                    <img class="image col-xs-3" id="exit" src="@/assets/exit.png" height="35" width="35" alt="" />
                  </router-link> 
                </a> 
            </div>
            <div class="card-body">
                <form v-on:submit.prevent="updateItem"> 
                    <div class="form-group">
                        <label>Category:</label>
                        <input type="text" class="form-control" v-model="newItem.category"/>
                    </div>
                    <div class="form-group">
                        <label>Product:</label>
                        <input type="text" class="form-control" v-model="newItem.photo"/>
                    </div>
                     <div class="form-group">
                        <label>Name:</label>
                        <input type="text" class="form-control" v-model="newItem.name"/>
                    </div>
                     <div class="form-group">
                        <label>Description:</label>
                        <input type="text" class="form-control" v-model="newItem.descr"/>
                    </div>
                    <div class="form-group">
                        <label>Currency:</label>
                        <input type="text" class="form-control" v-model="newItem.currency"/>
                    </div>
                    <div class="form-group">
                        <label>Price:</label>
                        <input type="text" class="form-control" v-model="newItem.price"/>
                    </div>
                    <div class="form-group">
                        <label>Discount:</label>
                        <input type="text" class="form-control" v-model="newItem.discount"/>
                    </div>
                    <div class="checkbox">
                        <label>
                            <input type="checkbox" data-toggle="toggle" v-model="newItem.special">
                            Is Special?
                        </label>
                    </div>


                    <div class="form-group">
                        <input type="submit" class="btn btn-primary" value="Update Item"/>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
  import firebase from 'firebase'
  import { db } from '../main';

  export default {
    components: {
        name: 'Editproductitem'
    },
    /*firestore() {
      items: db.collection('products')
    },*/
    data () {
      return {
        newItem: {}
      }
    },
    created() {     
     db.collection("products").where('name','==', this.$route.params.id).get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
              //alert(doc.data().name);
              this.newItem = {
                  id: doc.id,
                  category: doc.data().category,
                  photo: doc.data().photo,
                  name: doc.data().name,
                  descr: doc.data().descr,
                  currency: doc.data().currency,
                  price: doc.data().price,
                  discount: doc.data().discount,
                  special: doc.data().special
                  
              }
            })
          })  
    },
    methods: {
      updateItem() {
        //alert('ID: ' + this.newItem.id);
        //db.collection("products").where("name", "==", this.newItem.name).get().then((querySnapshot) => {
        db.collection("products").where(firebase.firestore.FieldPath.documentId(), "==", this.newItem.id).get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                db.collection("products").doc(doc.id).update({category: this.newItem.category });
                db.collection("products").doc(doc.id).update({name: this.newItem.name });
                db.collection("products").doc(doc.id).update({photo: this.newItem.photo });
                db.collection("products").doc(doc.id).update({descr: this.newItem.descr });
                db.collection("products").doc(doc.id).update({currency: this.newItem.currency });
                db.collection("products").doc(doc.id).update({price: this.newItem.price });
                db.collection("products").doc(doc.id).update({special: this.newItem.special });
                db.collection("products").doc(doc.id).update({discount: this.newItem.discount });
            });
        })
        alert('update succesfully.');
        this.$router.push('/viewlistproduct')
        //this.$router.push('/home')
      }
    }

  }
</script>


// WEBPACK FOOTER //
// src/components/editproductitem.vue